export const SUPPORTED_PLATFORMS = ['telegram', 'slack', 'discord', 'wechat', 'whatsapp', 'imessage'];

export const platformLabel = (platform: string): string => {
	switch (platform) {
		case 'telegram': return 'Telegram';
		case 'slack': return 'Slack';
		case 'discord': return 'Discord';
		case 'wechat': return 'WeChat';
		case 'whatsapp': return 'WhatsApp';
		case 'imessage': return 'iMessage';
		default: return platform.charAt(0).toUpperCase() + platform.slice(1);
	}
};

export const platformIcon = (platform: string): string => {
	switch (platform) {
		case 'telegram': return 'T';
		case 'slack': return 'S';
		case 'discord': return 'D';
		case 'wechat': return 'W';
		case 'whatsapp': return 'W';
		case 'imessage': return 'i';
		default: return '?';
	}
};

export const platformColor = (platform: string): string => {
	switch (platform) {
		case 'telegram': return 'bg-blue-500';
		case 'slack': return 'bg-purple-500';
		case 'discord': return 'bg-indigo-500';
		default: return 'bg-slate-500';
	}
};
